import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'

const OptionsStats = ({ lesson: { options, name }, exerciseStats, intl }) => (
  <div className="options-item options-stats">
    <h4>{name}</h4>
    {
      options.questions.map((question, questionId) => exerciseStats.answers[questionId] ?
        <div className="item-box" key={questionId}>
          <h5>{question.text}</h5>
          <span>
            {intl.formatMessage(messages.successRate)}:&nbsp;
            {exerciseStats.answers[questionId].successRate} %
          </span>
        </div>
        : null,
      )
    }
  </div>
)

OptionsStats.propTypes = {
  lesson: PropTypes.object.isRequired,
  exerciseStats: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
}

export default injectIntl(OptionsStats)

const messages = defineMessages({
  successRate: {
    id: 'stats.exercise.successRate',
    defaultMessage: 'Úspešnosť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/OptionsStats.js